import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loadedSneakers: [],
        loadedBrands: [],
        user: null,
        loading: false,
        authError: null
    },
    mutations: {
        addSneakerToWishlist (state, payload) {
            let wishlist = state.user.wishlist
            if (wishlist.findIndex(sneaker => sneaker.slug === payload.sneaker.slug) >= 0) {
                return
            } 
            state.user.wishlist.push(payload.sneaker)
        },
        removeSneakerFromWishlist (state, payload) {
            const wishlist = state.user.wishlist
            wishlist.splice(wishlist.findIndex(sneaker => sneaker.slug === payload.slug), 1)
        },
        addSneakerToCollection (state, payload) {
            let collection = state.user.collection
            if (collection.findIndex(sneaker => sneaker.slug === payload.sneaker.slug) >= 0) {
                return
            } 
            state.user.collection.push(payload.sneaker)
        },
        removeSneakerFromCollection (state, payload) {
            const collection = state.user.collection
            collection.splice(collection.findIndex(sneaker => sneaker.slug === payload.slug), 1)
        },
        setLoadedBrands (state, payload) {
            state.loadedBrands = payload
        },
        setLoadedSneakers (state, payload) {
            state.loadedSneakers = payload
        },
        setUser (state, payload) {
            state.user = payload
        },
        setLoading (state, payload) {
            state.loading = payload
        },
        setError (state, payload) {
            state.error = payload
        },
        clearError (state) {
            state.error = null
        }
    },
    actions: {
        addSneakerToWishlist ({commit, getters}, payload) {
            const user = getters.user
            const wishlist = getters.user.wishlist
            if (wishlist.findIndex(sneaker => sneaker.slug === payload.slug) >= 0) {
                return
            }
            firebase.database().ref('/users/' + user.id + '/wishlist').child(payload.slug)
                .set(payload)
                .then(data => {
                    commit('addSneakerToWishlist', { sneaker: payload })
                })
                .catch(error => {
                    console.log(error)
                }) 
        },
        removeSneakerFromWishlist ({commit, getters}, payload) {
            const user = getters.user
            firebase.database().ref('/users/' + user.id + '/wishlist').child(payload.slug)
                .remove()
                .then(() => {
                    commit('removeSneakerFromWishlist', payload)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        addSneakerToCollection ({commit, getters}, payload) {
            const user = getters.user
            const collection = getters.user.collection
            if (collection.findIndex(sneaker => sneaker.slug === payload.slug) >= 0) {
                return
            }
            firebase.database().ref('/users/' + user.id + '/collection').child(payload.slug)
                .set(payload)
                .then(data => {
                    commit('addSneakerToCollection', { sneaker: payload })
                })
                .catch(error => {
                    console.log(error)
                }) 
        },
        removeSneakerFromCollection ({commit, getters}, payload) {
            const user = getters.user
            firebase.database().ref('/users/' + user.id + '/collection').child(payload.slug)
                .remove()
                .then(() => {
                    commit('removeSneakerFromCollection', payload)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        loadSneakers ({commit}) {
            firebase.database().ref('sneakers').orderByChild('release_date').on('value', function (data) {
                const sneakers = []
                const obj = data.val()
                for (let key in obj) {
                    sneakers.push({
                        brand: obj[key].brand,
                        description: obj[key].description || "",
                        image_url: obj[key].image_url,
                        model_name: obj[key].model_name,
                        original_price: obj[key].original_price,
                        release_date: obj[key].release_date,
                        release_date_pretty: obj[key].release_date_pretty,
                        slug: obj[key].slug
                    })
                }
                function compare(a,b) {
                      if (a.release_date < b.release_date && a.image_url != "")
                            return 1;
                      if (a.release_date > b.release_date && a.image_url != "")
                            return -1;
                      return 0;
                }
                sneakers.sort(compare)
                commit('setLoadedSneakers', sneakers)
            })
        },
        loadBrands ({commit}) {
            firebase.database().ref('brands').orderByChild('release_date').on('value', function (data) {
                const brands = []
                const obj = data.val()
                for (let key in obj) {
                    brands.push({
                        id: key,
                        name: obj[key].name,
                        releases_count: obj[key].releases_count,
                        hero_image_url: obj[key].hero_image_url
                    })
                }
                commit('setLoadedBrands', brands)
            }) 
        },
        signUserUp ({commit}, payload) {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then(
                    user => {
                        commit('setLoading', false)
                        const newUser = {
                            id: user.uid,
                            wishlist: [],
                            collection: []
                        }
                        commit('setUser', newUser)
                    }
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                        console.log(error)
                    }
                )
        },
        signUserIn ({commit}, payload) {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then(
                    user => {
                        commit('setLoading', false)
                        const newUser = {
                            id: user.uid,
                            wishlist: [],
                            collection: []
                        }
                        commit('setUser', newUser)
                    }
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                        console.log(error)
                    }
                )
        },
        autoSignIn ({commit}, payload) {
            commit('setUser', { id: payload.uid, wishlist: [], collection: [] })
        },
        fetchUserData ({commit, getters}) {
            let wishlist = []
            let collection = []
            firebase.database().ref('/users/' + getters.user.id + '/wishlist').once('value')
                .then(data => {
                    const obj = data.val()
                    for (let key in obj) {
                        wishlist.push(obj[key])
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            firebase.database().ref('/users/' + getters.user.id + '/collection').once('value')
                .then(data => {
                    const obj = data.val()
                    for (let key in obj) {
                        collection.push(obj[key])
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                const updatedUser = {
                    id: getters.user.id,
                    wishlist: wishlist,
                    collection: collection
                }
                commit('setUser', updatedUser)
        },
        logout ({commit}) {
            firebase.auth().signOut()
            commit('setUser', null)
        }
    },
    getters: {
        loadedBrands (state) {
            return state.loadedBrands
        },
        loadedBrand (state) {
            return (brandId) => {
                return state.loadedSneakers.filter((sneaker) => {
                    return sneaker.brand === brandId
                })
            }
        },
        loadedSneakers (state) {
            return state.loadedSneakers
        },
        loadedSneaker (state) {
            return (sneakerSlug) => {
                return state.loadedSneakers.find((sneaker) => {
                    return sneaker.slug === sneakerSlug
                })
            }
        },
        user (state) {
            return state.user
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js